<!--
  Excepción de wizard del styleguide (§3.12): hay trabajo sin guardar, así que el clic en el
  backdrop no cierra. La X, Esc y Cancelar sí — las tres pasan por `requestHide()` y confirman.
-->
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: '840px', maxWidth: '95vw' }"
  styleClass="payment-adjust-dialog"
>
  <ng-template pTemplate="header">
    <div class="pa-head" *ngIf="payment">
      <span class="pa-head-icon"><i class="fa-solid fa-wrench"></i></span>
      <div class="pa-head-text">
        <span class="pa-head-eyebrow">Ajustar pago</span>
        <h3>{{ payment.cliente || 'Sin cliente' }}</h3>
        <span class="pa-head-meta"
          >{{ payment.trackingKey }} · {{ payment.monto | currency: 'MXN' : 'symbol' : '1.2-2' }} ·
          {{ payment.fecha | date: 'dd/MM/yyyy' : 'UTC' }}</span
        >
      </div>
    </div>
    <button type="button" class="pa-close" (click)="requestHide()" aria-label="Cerrar"><i class="fa-solid fa-xmark"></i></button>
  </ng-template>

  <!--
    Los saldos, antes de decidir nada. El modal abría sin un solo número hasta previsualizar y
    Operaciones lo reportó tal cual: «no vemos los saldos».
  -->
  <div class="pa-saldos">
    <div class="pa-saldo" *ngFor="let s of saldos">
      <span class="pa-saldo-label">{{ s.label }}</span>
      <span class="pa-saldo-valor">{{ s.valor }}</span>
      <span class="pa-saldo-hint">{{ s.hint }}</span>
    </div>
  </div>

  <!-- Dónde aterrizó el dinero: responde «¿esto afecta al arrendamiento?» con folios reales -->
  <div class="pa-fold" *ngIf="!contextLoading">
    <button
      type="button"
      class="pa-fold-toggle"
      (click)="appsOpen = !appsOpen"
      [attr.aria-expanded]="appsOpen"
      [disabled]="!aplicaciones.length"
    >
      <i class="fa-solid fa-arrow-right-to-bracket"></i>
      <span *ngIf="aplicaciones.length">Aplicado a {{ aplicaciones.length }} arrendamiento{{ aplicaciones.length === 1 ? '' : 's' }}</span>
      <span *ngIf="!aplicaciones.length">Este pago no se ha aplicado a ninguna letra</span>
      <i class="fa-solid pa-fold-chevron" *ngIf="aplicaciones.length" [ngClass]="appsOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>

    <div class="pa-fold-body" *ngIf="appsOpen && aplicaciones.length">
      <div class="pa-app" *ngFor="let a of aplicaciones">
        <a class="pa-app-folio" [routerLink]="['/lease', a.leaseId]" target="_blank" *ngIf="a.leaseId">{{ a.folio || 'Arrendamiento' }}</a>
        <span class="pa-app-folio is-plain" *ngIf="!a.leaseId">{{ a.folio || 'Sin arrendamiento' }}</span>
        <span class="pa-app-letras" *ngIf="a.letras?.length">letra{{ a.letras.length === 1 ? '' : 's' }} {{ a.letras.join(', ') }}</span>
        <span class="pa-app-monto">{{ a.monto | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
        <span class="pa-app-fecha">{{ a.fecha | date: 'dd/MM/yyyy' : 'UTC' }}</span>
      </div>
      <p class="pa-fold-note"><i class="fa-solid fa-lock"></i> Ninguna acción de esta herramienta modifica estas aplicaciones.</p>
    </div>
  </div>

  <!-- Historial: informa la decisión, así que va antes de decidir. Plegado salvo al deshacer. -->
  <div class="pa-fold" *ngIf="contextLoading || auditEntries.length">
    <button
      type="button"
      class="pa-fold-toggle"
      (click)="auditOpen = !auditOpen"
      [attr.aria-expanded]="auditOpen"
      [disabled]="contextLoading"
    >
      <i class="fa-solid fa-clock-rotate-left"></i>
      <span *ngIf="contextLoading">Cargando la información del pago…</span>
      <span *ngIf="!contextLoading"
        >Este pago ya tiene {{ auditEntries.length }} ajuste{{ auditEntries.length === 1 ? '' : 's' }} en su bitácora</span
      >
      <i class="fa-solid pa-fold-chevron" *ngIf="!contextLoading" [ngClass]="auditOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>

    <div class="pa-fold-body" *ngIf="auditOpen && !contextLoading">
      <div
        class="pa-history-item"
        *ngFor="let e of auditEntries"
        [class.is-undone]="e.revertedAt"
        [class.is-target]="operation === 'REVERT' && auditEntryId === e._id"
      >
        <div class="pa-history-main">
          <strong>{{ actionLabel(e.action) }}</strong>
          <span class="pa-history-date">{{ e.date | date: 'dd/MM/yyyy HH:mm' }}</span>
          <p-tag *ngIf="e.revertedAt" severity="secondary" value="deshecho" icon="fa-solid fa-rotate-left"></p-tag>
        </div>
        <div class="pa-history-change" *ngIf="e.field">
          {{ auditFieldLabel(e.field) }}:
          <ng-container *ngIf="hasAuditValue(e.previousValue)"
            ><em>{{ auditValue(e.field, e.previousValue) }}</em> →</ng-container
          >
          <strong>{{ auditValue(e.field, e.newValue) }}</strong>
        </div>
        <div class="pa-history-reason" *ngIf="e.reason">“{{ e.reason }}”</div>
        <button
          pButton
          type="button"
          label="Deshacer este"
          icon="fa-solid fa-rotate-left"
          class="p-button-text p-button-sm"
          *ngIf="e.sePuedeDeshacer"
          (click)="undoEntry(e)"
          [disabled]="saving"
        ></button>
      </div>
    </div>
  </div>

  <!-- ── 1 · Qué hacer ───────────────────────────────────────────────── -->
  <section class="pa-step">
    <div class="pa-step-head">
      <span class="pa-step-num">1</span>
      <h4>¿Qué hacer con este pago?</h4>
    </div>

    <!--
      Evidencia en vez de recomendación. El sistema NO puede saber si un pago sobra: compartir clave
      y monto es la forma normal de un cliente con varios arrendamientos. Se muestran los datos y
      decide quien tiene el estado de cuenta.
    -->
    <div class="pa-evidencia" *ngIf="(group === 'posiblesDuplicados' || group === 'listado') && hayIguales" [class.is-sobran]="sobran > 0">
      <div class="pa-evidencia-head">
        <i class="fa-solid fa-clone"></i>
        <strong>{{ iguales.total }} pagos comparten esta clave y monto</strong>
        <span
          >· el cliente tiene {{ iguales.arrendamientosActivos }} arrendamiento{{ iguales.arrendamientosActivos === 1 ? '' : 's' }} activo{{
            iguales.arrendamientosActivos === 1 ? '' : 's'
          }}</span
        >
      </div>

      <div class="pa-evidencia-lista">
        <div class="pa-evidencia-item" *ngFor="let o of iguales.pagos">
          <p-tag [severity]="o.status === 'APPLIED' ? 'success' : 'secondary'" [value]="statusLabel(o.status)"></p-tag>
          <span class="pa-evidencia-destino">{{ o.arrendamientos?.length ? o.arrendamientos.join(', ') : 'sin aplicar' }}</span>
          <span class="pa-evidencia-fecha">{{ o.fecha | date: 'dd/MM/yyyy' : 'UTC' }}</span>
        </div>
      </div>

      <p class="pa-evidencia-lectura">
        <ng-container *ngIf="sobran > 0"
          >Sobran <strong>{{ sobran }}</strong> respecto a sus arrendamientos, así que es probable que alguno se haya cargado de más —
          confírmalo contra el estado de cuenta.</ng-container
        >
        <ng-container *ngIf="sobran <= 0"
          >Caben todos en sus arrendamientos, así que este podría ser la renta de otro y no un duplicado.</ng-container
        >
      </p>
    </div>

    <div class="pa-ops" [class.is-single]="availableOperations.length === 1">
      <button
        type="button"
        class="pa-op"
        *ngFor="let op of availableOperations"
        [class.is-active]="operation === op.key"
        (click)="selectOperation(op.key)"
      >
        <i [class]="op.icon"></i>
        <span class="pa-op-title">{{ op.title }}</span>
        <span class="pa-op-hint">{{ op.hint }}</span>
      </button>
    </div>

    <div class="pa-field" *ngIf="operation === 'CLOSE_REMAINDER'">
      <label for="pa-threshold">Hasta qué monto se considera residuo</label>
      <p-inputNumber
        inputId="pa-threshold"
        [(ngModel)]="remainderThreshold"
        mode="currency"
        currency="MXN"
        locale="es-MX"
        [min]="0"
        (onInput)="invalidatePreview()"
        [style]="{ width: '200px' }"
      ></p-inputNumber>
      <small>Por arriba de este monto el ajuste avisa que lo que se condona ya no es redondeo, es dinero.</small>
    </div>

    <!--
      Lo que NO cambia pesa tanto como lo que sí: casi todas las dudas de Operaciones eran miedo a
      mover algo del arrendamiento sin enterarse. Y la fila «Después» es la que aclara qué queda
      pendiente cuando el ajuste no cierra el caso por sí solo.
    -->
    <div class="pa-efectos" *ngIf="efectos.length">
      <span class="pa-efectos-title">Qué pasa si haces esto</span>
      <div class="pa-efecto" *ngFor="let e of efectos" [ngClass]="'is-' + e.tono">
        <i
          class="pa-efecto-icon fa-solid"
          [class.fa-circle-check]="e.tono === 'toca'"
          [class.fa-circle-minus]="e.tono === 'intacto'"
          [class.fa-triangle-exclamation]="e.tono === 'ojo'"
          [class.fa-arrow-right-long]="e.tono === 'despues'"
        ></i>
        <span class="pa-efecto-que">{{ e.que }}</span>
        <span class="pa-efecto-texto">{{ e.texto }}</span>
      </div>
    </div>
  </section>

  <!--
    ── 2 · Impacto ──────────────────────────────────────────────────────
    Un solo paso: antes de calcular muestra el botón, después el resultado. Antes eran dos pasos y
    el de en medio se quedaba con el encabezado y nada debajo.
  -->
  <section class="pa-step" *ngIf="operation">
    <div class="pa-step-head">
      <span class="pa-step-num">2</span>
      <h4>Revisa el impacto</h4>
    </div>

    <div class="pa-preview-cta" *ngIf="!preview">
      <div class="pa-preview-copy">
        <strong>Nada se ha escrito todavía.</strong>
        <span
          >El cálculo corre exactamente el mismo código que la aplicación y luego lo descarta, así que lo que veas es lo que va a
          pasar.</span
        >
      </div>
      <button
        pButton
        type="button"
        label="Previsualizar impacto"
        icon="fa-solid fa-calculator"
        (click)="requestPreview()"
        [disabled]="!canPreview || previewing"
        [loading]="previewing"
      ></button>
    </div>

    <div class="pa-warn is-error" *ngIf="previewError">
      <i class="fa-solid fa-circle-xmark"></i>
      <div>
        <strong>No se pudo calcular el impacto</strong><span>{{ previewError }}</span>
      </div>
    </div>

    <ng-container *ngIf="preview">
      <div class="pa-impact">
        <div class="pa-impact-row" *ngFor="let r of impactRows" [class.is-changed]="r.cambia">
          <span class="pa-impact-label">{{ r.label }}</span>
          <div class="pa-impact-values">
            <span class="pa-impact-before" *ngIf="r.cambia">{{ r.antes }}</span>
            <i class="fa-solid fa-arrow-right-long" *ngIf="r.cambia"></i>
            <span class="pa-impact-after">{{ r.despues }}</span>
          </div>
          <span class="pa-impact-tag" *ngIf="!r.cambia">sin cambio</span>
        </div>
      </div>

      <!--
        El libro mayor de aplicaciones es lo que decide cuánto saldo se devuelve; mostrarlo evita
        que el número parezca salido de la nada.
      -->
      <div class="pa-ledger">
        <i class="fa-solid fa-book"></i>
        <span
          >Según sus aplicaciones vivas, este pago ya aplicó
          <strong>{{ preview.appliedByApplications | currency: 'MXN' : 'symbol' : '1.2-2' }}</strong> de
          <strong>{{ payment.monto | currency: 'MXN' : 'symbol' : '1.2-2' }}</strong
          >.</span
        >
      </div>

      <!-- Advertencias: cada bloqueante se confirma por separado -->
      <div class="pa-warnings" *ngIf="preview.warnings?.length">
        <div class="pa-warn" *ngFor="let w of preview.warnings" [class.is-blocking]="w.blocking">
          <i class="fa-solid" [ngClass]="w.blocking ? 'fa-triangle-exclamation' : 'fa-circle-info'"></i>
          <div>
            <strong>{{ warningLabel(w.code) }}</strong>
            <span>{{ w.message }}</span>
            <div class="field-checkbox" *ngIf="w.blocking">
              <p-checkbox [(ngModel)]="confirmations[w.code]" [binary]="true" [inputId]="'pa-warn-' + w.code"></p-checkbox>
              <label [for]="'pa-warn-' + w.code">Entiendo y confirmo</label>
            </div>
          </div>
        </div>
      </div>

      <button
        pButton
        type="button"
        label="Volver a calcular"
        icon="fa-solid fa-arrow-rotate-left"
        class="p-button-text p-button-sm pa-recalc"
        (click)="invalidatePreview()"
        [disabled]="saving"
      ></button>
    </ng-container>
  </section>

  <!-- ── 3 · Confirmar ───────────────────────────────────────────────── -->
  <section class="pa-step" *ngIf="preview">
    <div class="pa-step-head">
      <span class="pa-step-num">3</span>
      <h4>Confirma el ajuste</h4>
    </div>

    <div class="pa-field">
      <label for="pa-reason">Motivo del ajuste <span class="pa-req">obligatorio</span></label>
      <textarea
        id="pa-reason"
        pInputTextarea
        [(ngModel)]="reason"
        rows="3"
        [maxlength]="500"
        placeholder="Ej.: Conciliado contra el estado de cuenta del 15/04 — el depósito sí entró y no se aplicó a ninguna letra."
      ></textarea>
      <small>Queda en la bitácora del pago junto con tu nombre y la fecha. Es lo que permite deshacer esto después.</small>
    </div>
  </section>

  <ng-template pTemplate="footer">
    <!-- Confirmación EN LÍNEA al descartar: un confirm() nativo bloquea la página entera -->
    <ng-container *ngIf="confirmingClose; else footerNormal">
      <span class="pa-discard-msg"><i class="fa-solid fa-triangle-exclamation"></i> Se perderá lo capturado. ¿Cerrar de todos modos?</span>
      <button pButton type="button" label="Seguir aquí" class="p-button-text" (click)="cancelClose()"></button>
      <button pButton type="button" label="Sí, cerrar" icon="fa-solid fa-xmark" class="p-button-danger" (click)="hide()"></button>
    </ng-container>
    <ng-template #footerNormal>
      <button pButton type="button" label="Cancelar" class="p-button-text" (click)="requestHide()" [disabled]="saving"></button>
      <button
        pButton
        type="button"
        label="Aplicar ajuste"
        icon="fa-solid fa-check"
        (click)="apply()"
        [disabled]="!canApply"
        [loading]="saving"
      ></button>
    </ng-template>
  </ng-template>
</p-dialog>
